export default __webpack_public_path__ + "93a303e28f130834c6af34d0fd2ac8b5.svg";